// extracted by mini-css-extract-plugin
module.exports = {"locationContainer":"hotel_location_locationContainer__XUyVl","icon":"hotel_location_icon__-OGcF"};